import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WORKSPACE_FORM_FRAGMENT } from '../../useGetWorkspace/api/fragment'
import { Data, Variables } from './types'

export const CREATE_WORKSPACE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${WORKSPACE_FORM_FRAGMENT}
  ${ERROR_FRAGMENT}

  mutation createWorkspace($input: CreateWorkspaceInput!) {
    createWorkspace(input: $input) {
      workspace {
        ...WorkspaceFormFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
